import { render } from "./RegularInput.vue?vue&type=template&id=7d1804ac&ts=true"
import script from "./RegularInput.vue?vue&type=script&lang=ts"
export * from "./RegularInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__